import React, { useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { motion, useInView } from "framer-motion";
import CountUp from "react-countup";
import "./About.css"; // Import custom styles

const About = () => {
  const statsRef = useRef(null);
  const inView = useInView(statsRef, { triggerOnce: true, threshold: 0.5 }); // Trigger animation when 50% visible

  return (
    <motion.div
      id="about"
      className="container my-5"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true, amount: 0.05 }} // Ensures animation triggers when 20% of the section is visible
    >
      <div className="row align-items-center">
        {/* Text Section */}
        <div className="col-lg-6">
          <h3 className="about-heading fw-bold mb-2">About Us</h3>
          <h1 className="fw-bold">
            Leading Manufacturer of High-Quality HM-LDPE Bags
          </h1>
          <p>
            Sati Multiplast is one of the leading manufacturers, exporters, &
            suppliers of a variety of HM & LDPE and PP plastic Rolls & Bags of
            various sizes for packaging. Owing to their non-toxic, recyclable
            features, these are used in industries like Food, Chemical, and
            Pharmaceuticals. These are manufactured in our production unit,
            which has a clean and dust-free environment. We are competent to
            study and discuss client-specific requirements.
          </p>

          <p>
            We have been in this field since March 1997, and we have established
            a name for ourselves for very quick & efficient service. The company
            partners have 20 years of experience in the manufacturing sector.
            With a perfect blend of rich experience, excellent skills, and the
            latest technologies, we are happy to serve our clients with prime
            quality materials. We specialize in the business of plastic films
            and bag production as well as the printing industry. We also hold
            expertise in various types of bag and roll manufacturing.
          </p>
        </div>

        {/* Image Section */}
        <motion.div
          className="col-lg-6 text-center mt-4 mt-lg-0"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.2 }}
        >
          <img
            src="logosati.png"
            alt="About Us"
            className="img-fluid about-image"
          />
        </motion.div>
      </div>

      {/* Horizontal Line */}
      <hr className="my-4" />

      {/* Statistics Section with Animation */}
      <div ref={statsRef} className="row text-center stats-section py-4">
        {[
          { label: "Plant Size in Sqfeet", end: 40000 },
          { label: "Capacity in Tons", end: 140, suffix: "+" },
          { label: "Countries", end: 40 },
          { label: "Clients", end: 50, suffix: "+" },
          { label: "Workforce", end: 100, suffix: "+" },
          { label: "Cr in FY 2023-24", end: 126, prefix: "₹", suffix: "+" },
        ].map((item, index) => (
          <div className="col-md-2" key={index}>
            <h2 className="fw-bold text-danger">
              <CountUp
                start={inView ? 0 : null} // Starts counting only when visible
                end={inView ? item.end : 0} // Stops at end value
                duration={2.5}
                separator=","
                prefix={item.prefix || ""}
                suffix={item.suffix || ""}
              />
            </h2>
            <p>{item.label}</p>
          </div>
        ))}
      </div>
    </motion.div>
  );
};

export default About;
